export default {
  id: "fatbet",
  edition: "fatbet",
  displayName: "Fatbet",
  siteDomain: "fatbet.co.za",
  paymentHostPrefix: "api.payment",
  /**
   * Express mount as registered with Slotegrator (legacy host-in-path).
   * Do not normalize to `/slotegrator` without updating the provider callback and nginx.
   * Env `SLOTEGRATOR_CALLBACK_PATH` overrides. Daily-dev uses `/slotegrator`.
   */
  slotegratorCallbackPath: "/slotegratorapi.fatbet.org/slotegrator",
  /** Player-facing game iframe origin when Slotegrator proxy is on. */
  slotegratorProxyUrl: "https://initgame.fatbet.casino/slotegrator",
  apkDownloadName: "fatbet-app.apk",
  defaultPublicUrls: {
    frontend: "https://fatbet.co.za",
    backend: "https://api.fatbet.co.za",
    backendPayment: "https://api.payment.fatbet.co.za",
    frontendAdmin: "https://dashboard.fatbet.co.za",
    affilatePortal: "https://affilate.fatbet.org",
    affilateBackend: "https://api.affilate.fatbet.org",
    affilateAdmin: "https://admin.affilate.fatbet.org",
  },
  /** Telegram Login Widget domains → env keys in /etc/fatbet/main-backend.env */
  telegramBots: {
    "fatbet.co.za": {
      keysEnv: [
        "TELEGRAM_FATBET_CASINO_KEY",
        "TELEGRAM_FATBET_ORG_KEY",
        "TELEGRAM_1FATBET_COM_KEY",
        "TELEGRAM_1FATBET_ORG_KEY",
        "TELEGRAM_FATBET_SITE_KEY",
        "TELEGRAM_FAT_BET_XYZ_KEY",
        "TELEGRAM_FATBET_CO_ZA_KEY",
      ],
      nameEnv: "TELEGRAM_FATBET_CO_ZA_NAME",
      idEnv: "TELEGRAM_FATBET_CO_ZA_ID",
    },
    "fatbet.casino": {
      keysEnv: ["TELEGRAM_FATBET_CASINO_KEY"],
      nameEnv: "TELEGRAM_FATBET_CASINO_NAME",
      idEnv: "TELEGRAM_FATBET_CASINO_ID",
    },
    "fatbet.org": {
      keysEnv: ["TELEGRAM_FATBET_ORG_KEY"],
      nameEnv: "TELEGRAM_FATBET_ORG_NAME",
      idEnv: "TELEGRAM_FATBET_ORG_ID",
    },
    "1fatbet.com": {
      keysEnv: ["TELEGRAM_1FATBET_COM_KEY"],
      nameEnv: "TELEGRAM_1FATBET_COM_NAME",
      idEnv: "TELEGRAM_1FATBET_COM_ID",
    },
    "1fatbet.org": {
      keysEnv: ["TELEGRAM_1FATBET_ORG_KEY"],
      nameEnv: "TELEGRAM_1FATBET_ORG_NAME",
      idEnv: "TELEGRAM_1FATBET_ORG_ID",
    },
    "fatbet.site": {
      keysEnv: ["TELEGRAM_FATBET_SITE_KEY"],
      nameEnv: "TELEGRAM_FATBET_SITE_NAME",
      idEnv: "TELEGRAM_FATBET_SITE_ID",
    },
    "fat-bet.xyz": {
      keysEnv: ["TELEGRAM_FAT_BET_XYZ_KEY"],
      nameEnv: "TELEGRAM_FAT_BET_XYZ_NAME",
      idEnv: "TELEGRAM_FAT_BET_XYZ_ID",
    },
    "fatbet-gli.online": {
      keysEnv: ["TELEGRAM_FATBET_GLI_ONLINE_KEY"],
      nameEnv: "TELEGRAM_FATBET_GLI_ONLINE_NAME",
      idEnv: "TELEGRAM_FATBET_GLI_ONLINE_ID",
    },
  },
  composeFile: "editions/fatbet/docker-compose.yml",
  timezone: "Africa/Johannesburg",
  timezoneLabel: "ZA",
  defaultCurrency: "ZAR",
  extraCurrencies: [],
  markets: {
    mode: "single",
    region: "south africa",
  },
  sportsbook: {
    themeName: "fatbet",
    host: "https://fatbet.sptpub.com",
  },
  /**
   * Per-surface identity. Empty tracker = do not load.
   * Omitted emails/mailgun/sms/telegram inherit from `apps.main`.
   */
  apps: {
    main: {
      emails: {
        support: "support@fatbet.co.za",
        noreply: "noreply@fatbet.co.za",
      },
      mailgun: {
        domain: "mg.fatbet.co.za",
        from: "postmaster@mg.fatbet.co.za",
      },
      mailFromName: "Fatbet",
      smsFrom: "FatBet",
      supportTelegramBot: "fatbetmirrorbot",
      tawkEmbedUrl: "https://embed.tawk.to/6516917f10c0b2572486be1a/1hbg2gn5c",
      yandexMetrikaId: "106369328",
      gtmContainerId: "GTM-NR9L9BFV",
      gaMeasurementId: "G-0HBW93MLQ5",
    },
    affilate: {
      emails: {
        support: "support@fatbet.co.za",
        noreply: "noreply@fatbet.co.za",
        contact: "affilate@fatbet.org",
      },
      mailgun: {
        domain: "mg.fatbet.co.za",
        from: "postmaster@mg.fatbet.co.za",
      },
      mailFromName: "Fatbet Affilate",
      smsFrom: "FatBet",
      supportTelegramBot: "affilate_fatbet",
      tawkEmbedUrl: "",
      yandexMetrikaId: "96739069",
    },
    dashboard: {
      tawkEmbedUrl: "",
      yandexMetrikaId: "",
      gtmContainerId: "",
      gaMeasurementId: "",
    },
    affilateAdmin: {
      tawkEmbedUrl: "",
      yandexMetrikaId: "",
      gtmContainerId: "",
      gaMeasurementId: "",
    },
  },
  features: {
    sportsbookLive: false,
    sportsbookUi: true,
    androidApp: true,
  },
  licensee: {
    name: "Company Name",
    licenseCode: "111111",
    address: "Company Address",
  },
};
